const cta_getstarted = {
    title: "What can Globstudy do for you?",
    description: "To learn all about how Globstudy can help you gain admission to your dream university, schedule a free consultation with an academic mentor today.",
    link: "/consultation",
    actionText: "Sign Up"
}

export default cta_getstarted;